import React, {Component} from 'react';
import {InputItem, Toast} from 'antd-mobile';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as userAction from '../../reduxModule/actions/user';
import storage from '../../utils/localStore';
import './style.less';
import {login} from "../../service/loginService";

const logo = require('../../common/image/logo.png');
@connect(
    state => ({userInfo: state.userInfo}),
    dispatch => bindActionCreators(userAction, dispatch)
)
export default class Login extends Component {
    constructor(props) {
        super(props);
        this.state = {
            account: '',
            password: '',
            check: true
        };
    }

componentDidMount(){
    　if (this.state.account.replace(/\s/ig, '').length > 4 && this.state.password.length > 5) {
        this.setState({
            check: false
        });
    } else {
        this.setState({
            check: true
        });
    }
}
    // 手机号验证
    telChange = (value) => {
        this.setState({
            account: value
        });

        if (value.replace(/\s/ig, '').length > 4 && this.state.password.length > 5) {
            this.setState({
                check: false
            });
        } else {
            this.setState({
                check: true
            });
        }
    };

    // 密码验证
    pwdChange = (value) => {
        this.setState({
            password: value
        });

        if (value.length > 5 && this.state.account.replace(/\s/ig, '').length > 4) {
            this.setState({
                check: false
            });
        } else {
            this.setState({
                check: true
            });
        }
    };

    // 登录
    ok = () => {
        const {userLogin} = this.props;
        let params = {
            source:6,
            username: this.state.account.replace(/\s/ig, ''),
            password: this.state.password,
            grant_type:"password",
			scope:"server"
        };
        login(params)
            .then((res) => {
                console.log(82,res)
                if(res.data.access_token){
                        let usr = {
                            token: res.data.access_token,
                            account:this.state.account.replace(/\s/ig, ''),
                            userId:res.data.user_id,
                        };
                        storage.setItem('usr', usr);
                        userLogin(usr);
                        Toast.success('登录成功！', 2,()=> this.props.history.push('/home'));
                }
                // if (res.data.code === '0000') {
                
                //     userLogin(usr);
                //     Toast.success('登录成功！', 2,()=> this.props.history.push('/home'));
                //     document.location = `js://getToken?token=${res.data.data.access_token}`;
                // } else {
                //     Toast.info(res.data.msg);
                // }
            }).catch(function (error) {
                console.log(96,error.response.data.msg);
                Toast.info(error.response.data.msg);
            });
    };

    render() {
        return (
            <div className="loginScreen">

                <div className="content">
                <img src={logo}/>
                    <div className="title">智慧出行管理端</div>
                    <InputItem
                        className={this.state.account.replace(/\s/ig, '').length === 0 ? "usernameA" : "usernameB"}
                        type="text"
                        clear
                        placeholder="请输入工号"
                        value={this.state.account}
                        onChange={this.telChange}
                    >账号</InputItem>

                    <InputItem
                        className={this.state.password.replace(/\s/ig, '').length === 0 ? "passwordA" : "passwordB"}
                        maxLength={16}
                        placeholder="请输入密码"
                        value={this.state.password}
                        onChange={this.pwdChange}
                        type="password"
                    >密码</InputItem>

                    <div className="forgetPwd"><span onClick={() => {
                        this.props.history.push('/resetPwd', {type: 'reset'});
                    }}>忘记密码?</span>
                    </div>

                    <button disabled={this.state.check} onClick={this.ok}>登 录</button>
                </div>

            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/container/Login/index.js